import { createField, createColumns } from "./release-result-product.section";
import lodash from "lodash";
import { createPage } from "../../../../../../utils/page";
import { createLoading } from "../../../../../../utils/loading";
import store from "../../../../../../store";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/releaseProduct";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });

export const initForm = ({ props, data, refs }) => {
    const key = props.dataKey;
    const isLoading = props.isLoading;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    data.fields = createField({ props, data, refs, key, isLoading });
    if (model.id) {
        data.products = {
            fetchCriteria: {
                select: ["**"],
                page: 0,
                size: 1000000,
                where: [{ name: "refRelease.id", type: "UUID", operator: "=", value: model.id }],
                sort: [{ name: "createDate", type: "ASC" }]
            }
        };
    }
};

export const initData = ({ props, data }) => {
    const { itemsKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    data.columns = createColumns({ props, data });
    data.page = createPage({ data: items });
    data.tableOptions = { search: { activeKey: null } };
    data.manages = [];
    data.manageExtras = [];
    data.rowActions = [];
    fetchData({ props, data }).then(page => {
        page.data?.forEach(d => {
            const productQties = d.refInspectionProduct?.productQties;
            d.numberOfPackage = lodash.sum(productQties?.map(it => it.numberOfPackage) || [0]);
            d.qty = lodash.sum(productQties?.map(it => it.qty) || [0]);
            d.refPackageUnit = productQties?.[0]?.refPackageUnit;
            d.refPackagingCharacteristic = productQties?.[0]?.refPackagingCharacteristic;
            d.refQtyUnit = productQties?.[0]?.refQtyUnit;
        })

        items.push(...page.data)
    });
};

export const fetchData = ({ props }) => {
    const { fetchCriteria } = props;
    if (!fetchCriteria || fetchCriteria.fetched) {
        return Promise.resolve({ data: [] });
    }
    setIsLoading(true);
    return callSearch({ criteria: fetchCriteria }).finally(() => {
        fetchCriteria.fetched = true;
        setIsLoading(false)
    });
};
